<template>
  <div class="worth-container">
    <img src="https://ysh-cdn.kaidicloud.com/app/h5/app_download_introduce_1.png" />
    <img src="https://ysh-cdn.kaidicloud.com/app/h5/app_download_introduce_2.png" />
    <img src="https://ysh-cdn.kaidicloud.com/app/h5/app_download_introduce_3.png" />

    <div class="botttom-button" @click="sendClickDownloadAppEvent()">
      <wx-open-launch-app style="position: absolute;left: 50%;top: 4px;transform: translate(-50%);" v-if="isAndroid && isWechat && wxOpenTagInit" id="launch-btn" appid="wxbd5bb1cba389cb65" :extinfo="extinfo" @launch="handleWxLaunch" @error="handleWxError">
        <script type="text/wxtag-template">
            <img style="display:block;width:251px;height:59px;" src="https://ysh-cdn.kaidicloud.com/app/h5/ic_download_btn.png" />
        </script>
      </wx-open-launch-app>
      <img v-else class="btn" id="downloadYshApp" src="https://ysh-cdn.kaidicloud.com/app/h5/ic_download_btn.png" />
      <img class="btn-bg" src="https://ysh-cdn.kaidicloud.com/app/h5/ic_download_btn_bg.png" />
    </div>
    <div class="weixin-tips-container" v-if="isWechat && showTipLayer" @click="onclickTipLayer">
      <img class="open-in-web" src="https://ysh-cdn.kaidicloud.com/app/h5/open_in_browser_icon.png" />
    </div>
    <modal
      content="如未正常唤起，请点击下面按钮下载APP，或在浏览器中打开重试。"
      :width="300"
      :top="200"
      type="info"
      mode="info"
      noticeText="点击下载"
      @cancel="onCancel"
      @ok="onConfirm"
      :visible="showModal"
    />
  </div>
</template>

<script>
import { getAppVersionConfig } from '@/api/data'
import { sendClickLog, sendPageLog } from '@/api/srd'
import { getOpenWxToken } from '@/api'
import wx from 'weixin-js-sdk'

export default {
  components: {
    Modal: () => import('../../components/Modal.vue'),
  },
  data() {
    return {
      downloadUrl: '',
      query: '',
      showModal: false,
      appQuery: '',
      showTipLayer: false,
      isWechat: false,
      appId: '', // 必填，公众号的唯一标识
      timestamp: '', // 必填，生成签名的时间戳
      nonceStr: '', // 必填，生成签名的随机串
      signature: '', // 必填，签名
      extinfo:'',
      // 微信开放标签是否初始化成功
      wxOpenTagInit: true,
    }
  },
  computed: {
    isAndroid() {
      const u = navigator.userAgent
      return u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 //android终端
    },
  },
  created() {},
  mounted() {
    let Navigator = navigator.userAgent
    this.isWechat = Navigator.indexOf('MicroMessenger') >= 0

    let { path = '', ...res } = this.$route.query || {}

    for (const [key, value] of Object.entries(res)) {
      this.query = key + '=' + value + '&' + this.query
    }

    if (this.query) {
      this.extinfo = '/' + path + '?' + this.query.substring(0, this.query.lastIndexOf('&'))
      this.appQuery = path + '?' + this.query.substring(0, this.query.lastIndexOf('&'))
    } else {
      this.appQuery = path
      this.extinfo = '/' + path
    }

    if (this.isEvn() == 'Android') {
      this.appQuery = 'yshapp://ysh:8888/' + this.appQuery
    }

    //  IOS  + this.appQuery
    // else {
    //   this.appQuery = 'h.kaidicloud.com/' + this.appQuery
    // }

    this.fetchData()
    this.initUlink()
    this.initWeixinSDK()
    this.sendPageEvent()
  },
  methods: {
    onclickTipLayer() {
      this.showTipLayer = false
    },
    async fetchData() {
      getAppVersionConfig('ysh_product').then((res) => {
        this.downloadUrl = res.data.data.fullUpdateInfo.downloadUrl
      })
    },
    download() {
      this.submitFn()
    },

    onCancel() {
      this.showModal = false
    },
    onConfirm() {
      this.showModal = false
      window.location.href = this.downloadUrl
    },

    initUlink() {
      const context = this
      //对接ulink
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = 'https://g.alicdn.com/jssdk/u-link/index.min.js'
      document.getElementsByTagName('head')[0].appendChild(script)
      //等待挂载完成
      script.onload = function () {
        const ULink = window.ULink
        const url = (window.location.href || '').split('?')[1]
        const data = ULink.getUriParams(url)
        console.log('ulink data',data)
        const ULinkId = process.env.VUE_APP_BUILD_ENV == 'pro' ? 'usr1e9po3atblsi0' : 'usr1ateucr9c8jf2'
        ULink([
          {
            id: ULinkId,
            data,
            useOpenInBrowerTips: 'default',
            selector: '#downloadYshApp',
            onready: function (ctx) {
              if (context.downloadUrl && ctx.solution) {
                ctx.solution.downloadUrl = context.downloadUrl
              }
            },
            proxyOpenDownload: function (defaultAction, LinkInstance) {
              if (LinkInstance.solution.type === 'scheme') {
                // qq或者微信环境特殊处理下
                if (ULink.isWechat || ULink.isQQ) {
                  // 在qq或者微信环境执行内置逻辑，具体内置逻辑为:当设置了useOpenInBrowerTips字段时，qq&&微信&&scheme时，启用蒙层提示去浏览器打开
                  defaultAction()
                } else {
                  context.showModal = true
                  // window.location.href = LinkInstance.solution.downloadUrl
                }
              } else if (LinkInstance.solution.type === 'universalLink') {
                // universalLink 唤起应当由服务端提供一个带重定向到appstore的universallink地址。因此，此处不应写逻辑，友盟会在近期上线universalLink 重定向功能。
              }
            },
          },
        ])
      }
    },
    async initWeixinSDK() {
      const that = this
      const { data } = await getOpenWxToken(window.location.href.split('#')[0])
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
        appId: data.data.appId, // 必填，公众号的唯一标识
        timestamp: data.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.data.nonceStr, // 必填，生成签名的随机串
        signature: data.data.sign, // 必填，签名
        jsApiList: ['wx-open-launch-app'], // 必填，需要使用的JS接口列表
        openTagList: ['wx-open-launch-app'], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
      })
      wx.ready(() => {
        console.log('wx.ready')
        const btn = document.getElementById('launch-btn')
        btn.addEventListener('ready', function (e) {
          that.wxOpenTagInit = true
        })
        btn.addEventListener('error', function (e) {
          that.wxOpenTagInit = false
        })
      })
    },

    handleWxLaunch(e) {
      var u = navigator.userAgent
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        window.location.href = this.appQuery
      }
      console.log('跳转成功', JSON.stringify(e))
    },
    handleWxError(e) {
      console.log('跳转失败', JSON.stringify(e))
    },
    sendClickDownloadAppEvent() {
      if (this.isWechat && !this.isAndroid) {
        this.showTipLayer = true
      }
      sendClickLog({
        function: 'T079',
        current_url: window.location.origin + window.location.pathname,
      })
    },

    sendPageEvent() {
      sendPageLog({
        current_url: window.location.origin + window.location.pathname,
      })
    },

    submitFn() {
      //判断浏览器
      var u = navigator.userAgent
      if (/MicroMessenger/gi.test(u)) {
        // 引导用户在浏览器中打开
        alert('请在浏览器中打开')
        return
      }
      var d = new Date()
      var t0 = d.getTime()
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        //Android
        this.openApp(this.appQuery)
        let that = this
        var delay = setInterval(function () {
          var d = new Date()
          var t1 = d.getTime()
          if (t1 - t0 < 3000 && t1 - t0 > 2000) {
            // alert('请下载APP')
            // console.log(that.downloadUrl)
            window.location.href = that.downloadUrl
          }
          if (t1 - t0 >= 3000) {
            clearInterval(delay)
          }
        }, 1000)
      } else if (u.indexOf('iPhone') > -1) {
        // window.location.href = this.appQuery

        window.location = 'https://apps.apple.com/app/id1631363552'

        // var delay = setInterval(function () {
        //   var d = new Date()
        //   var t1 = d.getTime()
        //   if (t1 - t0 < 3000 && t1 - t0 > 2000) {
        //     alert('请下载APP')

        //   }
        //   if (t1 - t0 >= 3000) {
        //     clearInterval(delay)
        //   }
        // }, 1000)

        // if (this.openApp(this.appQuery)) {
        //   this.openApp(this.appQuery)
        // } else {

        // }
      }
    },

    isEvn() {
      //判断浏览器
      var u = navigator.userAgent
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        return 'Android'
      } else if (u.indexOf('iPhone') > -1) {
        return 'iPhone'
      }
    },

    openApp(src) {
      // 通过iframe的方式试图打开APP，如果能正常打开，会直接切换到APP，并自动阻止a标签的默认行为
      // 否则打开a标签的href链接
      var ifr = document.createElement('iframe')
      ifr.src = src
      ifr.style.display = 'none'
      document.body.appendChild(ifr)
      window.setTimeout(function () {
        document.body.removeChild(ifr)
      }, 2000)
    },
  },
}
</script>

<style lang="less" scoped>
.worth-container {
  display: flex;
  flex-direction: column;
}

.worth-container img {
  width: 100vw;
  height: auto;
}

.botttom-button {
  width: 100vw;
  height: 150px;
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 0;
}

.botttom-button .btn {
  position: absolute;
  left: 50%;
  top: 8px;
  transform: translate(-50%);
  width: 502px;
  height: 118px;
}

.botttom-button .btn-bg {
  width: 100%;
  height: 150px;
}
.weixin-tips-container {
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  text-align: right;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
}

.weixin-tips-container .open-in-web {
  position: absolute;
  top: 10px;
  right: 50px;
  width: 366px;
  height: 232px;
  display: block;
}
</style>
